module Meevo.Plugins.Register {
    "use strict";

    export class RegisterSectionBase {
        refundSubTotal: number = 0;
        refundTax: number = 0;
		refundTotal: number = 0;
        
		protected template: string;

        constructor(public sectionType: Meevo.Plugins.Register.RegisterSectionTypeEnum,
            protected registerContext: Meevo.Plugins.Register.RegisterContext,
            sectionPath: string,
            public sectionCatType: Register.RegisterSectionCatTypeEnum) {
            this.template = sectionPath;
        }

        reset() {
        }

        edit(saleLine: any) {
        }

        delete(saleLine) {
        }

        hasItems() {
            return false;
        }

        isDirty() {
            return false;
        }   

        clientSelected() {
            
        }

        switchToServicesWhenClientSelected() {
            return true;
        }

        canApplyRefund(): boolean {
            return this.refundTotal > 0;
        }

        getRefundEmployeeDisplayName(saleLine) {
            if (saleLine && saleLine.employeeDisplayName) {
                return saleLine.employeeDisplayName;
            }
            else {
                return this.registerContext.HouseEmployee.displayName;
            }
        }

        getManualRefundMessage(historicalSaleLine) {
            let dateFilter: any = this.registerContext.$filter("meevoDateFilter");

            return this.registerContext.$translate.instant("MESSAGE_MANUAL_REFUND", {
                date: dateFilter(historicalSaleLine.saleDate),
                employeeName: this.getRefundEmployeeDisplayName(historicalSaleLine),
                price: this.registerContext.meevoCurrency(historicalSaleLine.finalItemPriceCharge),
                quantity: historicalSaleLine.quantity,
                itemType: historicalSaleLine.saleType === Model.SalesTypeEnum.Service ?
                    this.registerContext.appSettings.APP_FIELDLABELS["service"] :
                    this.registerContext.appSettings.APP_FIELDLABELS["product"]
            });
        }

        addRefundSaleLine(id, saleType, localReset) {
            const request = {
                criteria: {
                    clientId: this.registerContext.selectedClient.id,
                    itemId: id,
                    saleType: saleType
                },
                itemsPerPage: 1000,
                sortDirection: Model.SortDirection.Descending,
            };

            this.registerContext.dataService.getListPaged("SaleLine", request).then((data: any) => {
                let historicalSaleLine = data.shift();
                while (historicalSaleLine) {
                    let matchingRefundSaleLine = _(this.registerContext.sale.saleLines).
                        findWhere({ refundTransactionId: historicalSaleLine.transactionId });
                    if (!matchingRefundSaleLine) {
                        break;
                    }
                    historicalSaleLine = data.shift();
                }
                if (historicalSaleLine) {
                    this.registerContext.modalService.confirmHandler(this.getManualRefundMessage(historicalSaleLine),
                        Components.Modal.ModalTranslationModes.DoNotTranslate).then(confirmResponse => {
                            if (confirmResponse) {
                                this.registerContext.addRefundSaleLine(historicalSaleLine, saleType);
                                this.registerContext.recalculateSale()
                                    .then(() => {
                                        localReset();
                                    })
                                    .catch(() => {
                                        this.registerContext.selectSection(this.registerContext.previouslySelectedSection.sectionType, false);
                                        this.registerContext.sale.saleLines.pop();
                                    });
                            }
                            else {
                                this.registerContext.selectSection(RegisterSectionTypeEnum.Employee);
                            }
                        })
                }
                else {
                    this.registerContext.selectSection(RegisterSectionTypeEnum.Employee);
                }
            });
        }

        goToTransactionEditor(transactionId: string) {
            this.registerContext.$rootScope.$broadcast("gotoState", {
                stateName: this.registerContext.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: {
                    transactionId: transactionId,
                    includeActive: true,
                    includeCompleted: true,
                    includeOnHold: false,
                    includeRefunded: true,
                    includeVoided: true
                },
                securityKey: Meevo.Components.Common.SecurityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            });
        }

        hasExternalTipTransactionIdMismatch(lines: any[]) {
            const ids = lines.map(line => line.externalTipTransactionId).filter(id => id);
            return new Set(ids).size > 1;
        }

        hasAuthorizationPaymentRequestIdMismatch(lines: any[]) {
            const ids = lines.map(line => line.authorizationPaymentRequestId).filter(id => id);
            return new Set(ids).size > 1;
        }
    }
}